import types from '../types/addCreditCard'

const initialRoot = {
  code: '',
  loadingDeposit: true,
  loadingCard: false,
  number: '',
  expiry: '',
  cvc: '',
  cardholderName: '',
  documentType: 'DNI',
  documentNumber: '',
  type: '',
  errorDeposit: '',
  deposit: {},
  completed: false,
  success: false
}

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_CARD_NUMBER:
      return {...state, number: action.payload.number}
    case types.SET_CARD_EXPIRY:
      return {...state, expiry: action.payload.expiry}
    case types.SET_CARD_CVC:
      return {...state, cvc: action.payload.cvc}
    case types.SET_CARDHOLDER_NAME:
      return {...state, cardholderName: action.payload.cardholderName}
    case types.SET_DOCUMENT_TYPE:
      return {...state, documentType: action.payload.documentType}
    case types.SET_DOCUMENT_NUMBER:
      return {...state, documentNumber: action.payload.documentNumber}
    case types.SET_CARD_TYPE:
      return {...state, type: action.payload.type}
    case types.VALIDATE_CODE_AND_GET_DEPOSIT:
      return {
        ...state,
        code: action.payload.code,
        loadingDeposit: true,
        errorDeposit: '',
      }
    case types.VALIDATE_CODE_AND_GET_DEPOSIT_SUCCESS:
      const {completed, deposit} = action.payload
      return {
        ...state,
        completed,
        deposit,
        loadingDeposit: false,
      }
    case types.VALIDATE_CODE_AND_GET_DEPOSIT_FAIL:
      return {
        ...state,
        loadingDeposit: false,
        errorDeposit: action.payload.error,
      }
    case types.SAVE_CARD:
      return {
        ...state,
        loadingCard: true,
        error: '',
      }
    case types.SAVE_CARD_SUCCESS:
      return {
        ...state,
        loadingCard: false,
        success: true
      }
    case types.SAVE_CARD_FAIL:
      return {
        ...state,
        loadingCard: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/addCreditCard/reducers/addCreditCard.js